export const announcementsObject = {
    announcements: [],
    isLoading: false,
    error: null,
    isDismissing: false,
    dismissError: null,
};
